module.exports = __webpack_public_path__ + "static/media/adobestock-41456411-2000x834.314d7c23.jpg";